import React from 'react';
import { CheckIcon, ShieldCheckIcon, GlobeIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const badges = ['800+ Pages of Proven Systems', '1,000+ Ready-to-Use Prompts', 'Used by Top Agents in 4 Countries'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-900" data-id="element-51" data-mp="4m8ku8bjujit">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[radial-gradient(1200px_600px_at_15%_-10%,#234A66_0%,transparent_60%),radial-gradient(900px_500px_at_100%_100%,#153044_0%,transparent_55%)]" data-id="element-52" data-mp="129h37ug97cgl" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 grid-pattern opacity-40" data-id="element-53" data-mp="sartwq2fb0by" />

      <div className="relative mx-auto max-w-5xl px-5 sm:px-6 lg:px-8" style={{
      paddingTop: "12px",
      paddingBottom: "12px"
    }} data-id="element-54" data-mp="ncztf7npq5w5">
        <motion.div initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-55" data-mp="3d2tpjcx5eqg4">
          <p className="mb-6 inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold text-slate-200 sm:w-auto sm:px-16" style={{
          fontWeight: "800",
          paddingTop: "11px",
          paddingBottom: "11px",
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-56" data-mp="3j6fx1mlet7c9">
            <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-brand-gold" data-id="element-57" data-mp="30h9dxygpedpx" />
            KODA DIGITAL
          </p>

          <h1 className="text-white" style={{
          fontSize: "24px",
          fontWeight: "800"
        }} data-id="element-58" data-mp="35aucbrm7l9pn">
            <span className="block text-[26px] leading-[1.15] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-59" data-mp="2qi0o9hsvfl9d">
              THE TRADITIONAL AGENT IS DYING. <span className="text-brand-gold" data-id="element-60" data-mp="2hix2g62bkrr6">THE AI-POWERED ARCHITECT IS TAKING THE MARKET.</span>
            </span>
            <span className="mt-4 block text-base font-medium leading-relaxed text-slate-300 sm:text-lg" style={{
            marginTop: "0px",
            marginBottom: "0px",
            paddingTop: "0px",
            paddingBottom: "0px",
            width: "328px",
            height: "56px"
          }} data-id="element-61" data-mp="2ljgzl9mw7vdb">
              The rules of Real Estate just changed forever. You are either the one using the engine, or the one being crushed by it.
            </span>
          </h1>

          <motion.figure className="relative mt-8 sm:mt-10" initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-62" data-mp="degeefp1uar0">
            <div className="mx-auto w-full max-w-[420px] overflow-hidden rounded-2xl border border-white/10 shadow-2xl ring-1 ring-brand-gold/20 sm:max-w-[460px]" data-id="element-63" data-mp="111esj6pp56lr">
              <img src="https://cdn.magicpatterns.com/uploads/bS9CBFjnd5mFrWa2H7s2Tq/comprimido-1x1.jpg" alt="Real estate agent on a luxury balcony with AI data visualizations mapping a modern property" className="h-[301px] w-full object-cover object-[30%_center] sm:aspect-square sm:h-auto sm:object-center" width={1024} height={1024} loading="eager" data-id="element-64" data-mp="3lsoyt0hf3v83" />
            </div>
          </motion.figure>

          <p className="mt-8 text-base leading-relaxed text-slate-300 sm:text-center sm:text-lg" style={{
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-65" data-mp="26a98vi3676um">
            The 800+ page system that turns real estate agents into autonomous, deal-closing machines — built for
            the market you are actually selling in today.
          </p>

          <div className="flex flex-col items-stretch gap-3 sm:items-center" data-id="element-66" data-mp="2kxkk1ivfwou7">
            <CTAButton href="#offer" className="w-full sm:w-auto" data-id="element-67" data-mp="2p08tnsrz9zs8">
              <span className="block" style={{
              fontSize: "20px"
            }} data-id="element-68" data-mp="2tzlfqbb0z2tr">Discover what&rsquo;s inside</span>
              <span className="block" style={{
              fontSize: "20px"
            }} data-id="element-69" data-mp="umhe6cmywlov">See the complete system</span>
            </CTAButton>
            <p className="text-center text-sm text-slate-400" style={{
            fontSize: "12px"
          }} data-id="element-70" data-mp="zl10ie5h3zhr">
              Join <span className="font-semibold text-slate-200" data-id="element-71" data-mp="4aco3i0njza2">2,000+ agents</span> who&rsquo;ve already
              transformed their business.
            </p>

            <p className="flex items-center justify-center gap-1.5 text-center text-[12px] leading-tight text-slate-300" data-id="element-72" data-mp="e9k1u6batvxp">
              <GlobeIcon aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-brand-gold" data-id="element-73" data-mp="9a7c9dt1marf" />
              <span data-id="element-74" data-mp="3hpqz9v34ewy1">
                <span className="font-semibold text-white" data-id="element-75" data-mp="3hr2663rv4ktd">Global Edition:</span> Fully compatible with all
                international real estate markets.
              </span>
            </p>

            <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 pb-4" data-id="element-76" data-mp="3rh566nxeiz17">
              {badges.map(badge => <li key={badge} className="flex items-center gap-1.5 text-[13px] font-semibold leading-tight text-slate-200" data-id="element-77" data-mp="3mnshyewmwu8z">
                  <CheckIcon aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-brand-gold" data-id="element-78" data-mp="2yxg4ypmj87bj" />
                  {badge}
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </header>;
}